import useUserProfile from '~/apis/useUserProfile';
import { useAuth } from '~/auth';
import { useTranslate } from '~/i18n';
import { Section } from '../common/section';
import { StatisticsWidget } from '../common/statistics-widget';
import EmptyState from '../completed-dashboard/empty-states';
// import { HelpCenterSection } from './help-center.section';

export const IncompleteDashboard = () => {
   const { translate } = useTranslate();
   const { user, updateUser } = useAuth();
   useUserProfile({
      onSuccess: data => {
         if (data && data.status) {
            updateUser({ ...user, ...data });
         }
      },
   });

   return (
      <div className="p-5">
         {/* {!userProfileData?.uploaded_legal_docs && (
            <div
               className={
                  'p-6 mb-5 rounded-md text-sm border-[#646EC866] border bg-[rgba(255,209,121,0.5)] flex items-center flex-wrap gap-4 justify-between'
               }>
               <div className="flex flex-col gap-1">
                  <span className="font-semibold">
                     <Translate id="common:hello" />, {user?.current_user?.name || ''}
                  </span>
                  <Translate id="profile:please upload your documents" />
               </div>
               <button
                  onClick={() => {
                     setOpenOnboardingModal(true);
                  }}
                  className="bg-transparent border-grey-200 border px-4 py-2 rounded-md font-semibold disabled:cursor-not-allowed">
                  <Translate id="profile:complete your account" />
               </button>
            </div>
         )} */}
         <div className="flex flex-col gap-7">
            <div className="grid md:grid-cols-3 lg:grid-cols-4 grid-cols-2 col-span-5 gap-4 text-center ">
               <StatisticsWidget
                  icon="/icons/equalizer.svg"
                  title={translate({ id: 'dashboard:total sales' })}
                  count={0}
                  isCurrency
               />
               <StatisticsWidget
                  icon="/icons/voucher.svg"
                  title={translate({ id: 'dashboard:total orders sold' })}
                  count={0}
               />
               <StatisticsWidget
                  icon="/icons/balance.svg"
                  title={translate({ id: 'dashboard:available for payout' })}
                  count={0}
                  isCurrency></StatisticsWidget>
               {/* <StatisticsWidget
                  icon="/icons/payout.svg"
                  title={translate({ id: 'dashboard:wallet balance' })}
                  count={userProfileData?.wallet_balance || 0}
                  isCurrency></StatisticsWidget> */}
               <StatisticsWidget
                  icon="/icons/star.svg"
                  title={translate({ id: 'dashboard:NPS score' })}
                  count={0}
               />
            </div>

            <div className="h-full">
               <Section className=" py-8 px-5 h-full">
                  <EmptyState />
               </Section>
            </div>
         </div>
      </div>
   );
};
